import { CustomLink } from "custom";
import { Fragment, useState } from "react";
import { FiChevronDown, FiChevronRight, FiMinus } from "react-icons/fi";
import { slugify } from "utils";
import './index.scss'

interface Props {
    name: string
    img: string
    list: string[]
    handleCloseCategory: React.MouseEventHandler<HTMLDivElement>
}

export function DropDown(props: Props) {
    const [status, setStatus] = useState(false)


    return (
        <div className="floatingCategory-bottom-content-item" onMouseEnter={() => { setStatus(true) }} onMouseLeave={() => { setStatus(false) }}>
            <div className="floatingCategory-bottom-content-item-name">
                <CustomLink name="category" cat_name={slugify(props.name)}>
                    <Fragment>
                        <img src={props.img} alt={props.name} />
                        <span onClick={props.handleCloseCategory}>{props.name}</span>
                    </Fragment>
                </CustomLink>

                <i>
                    {status ? (<FiChevronDown />) : <FiChevronRight />}
                </i>
            </div>
            {status &&
                (
                    <div className="floatingCategory-bottom-content-item-sub">
                        {props.list.map(i => (
                            <CustomLink key={i} name="sub-category" cat_name={slugify(props.name)} sub_cat_name={slugify(i)}>
                                <Fragment>
                                    <i onClick={props.handleCloseCategory}>
                                        <FiMinus />
                                    </i>
                                    <span onClick={props.handleCloseCategory}>
                                        {i}
                                    </span>
                                </Fragment>
                            </CustomLink>
                        ))}
                    </div>
                )
            }
        </div>
    )

}
